import React, { useState, useEffect } from 'react';
import '../style.css';
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaShieldAlt, FaCar, FaUserFriends } from 'react-icons/fa';

const AirportTransfer = () => {
  const [selectedService, setSelectedService] = useState('standard');
  const [pickupLocation, setPickupLocation] = useState('Lal Bahadur Shastri International Airport');
  const [dropLocation, setDropLocation] = useState('');
  const [pickupDate, setPickupDate] = useState('');
  const [pickupTime, setPickupTime] = useState('');
  const [passengers, setPassengers] = useState(1);
  const [bookingStep, setBookingStep] = useState(1);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const services = [
  {
    id: 'ertiga',
    name: 'Maruti Ertiga',
    price: 3000,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tavera-Ertiga.jpg',
    description: 'Reliable 7-seater MPV, perfect for family trips and city travel in Varanasi.',
    features: [
      'AC',
      '7 Passengers',
      'Comfort Seating',
      'Ideal for Family',
      'Professional Driver'
    ]
  },
  {
    id: 'dzire',
    name: 'Swift Dzire',
    price: 2500,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Swift-Dzire.jpg',
    description: 'Affordable 4-seater sedan for city rides, airport transfers, and business travel.',
    features: [
      'AC',
      '4 Passengers',
      'Fuel Efficient',
      'City & Airport Rides',
      'Professional Driver'
    ]
  },
  {
    id: 'innova',
    name: 'Toyota Innova',
    price: 3200,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Innova.jpg',
    description: 'Trusted 7-seater SUV for city rides, corporate travel, and long-distance journeys.',
    features: [
      'Premium AC',
      '7 Passengers',
      'Spacious Interior',
      'Long Distance Comfort',
      'Professional Driver'
    ]
  },
  {
    id: 'tempo17',
    name: 'Tempo Traveller 17 Seater',
    price: 4000,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tempo-Traveller.jpg',
    description: 'Spacious 17-seater tempo traveller, best for large groups and tours.',
    features: [
      '17 Passengers',
      'Pushback Seats',
      'Large Luggage Space',
      'Group Travel',
      'Experienced Driver'
    ]
  },
  {
    id: 'crysta',
    name: 'Toyota Crysta',
    price: 4000,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Crysta.jpg',
    description: 'Luxury 7-seater SUV offering premium comfort and smooth rides.',
    features: [
      'Luxury Interior',
      'Premium AC',
      '7 Passengers',
      'Smooth Ride',
      'Professional Chauffeur'
    ]
  },
  {
    id: 'hondacity',
    name: 'Honda City',
    price: 4000,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Honda-City.jpg',
    description: 'Premium sedan for business travel, city rides, and airport pickups.',
    features: [
      'Luxury Sedan',
      'Premium AC',
      '4 Passengers',
      'Business Class Comfort',
      'Professional Driver'
    ]
  },
  {
    id: 'cruiser',
    name: 'Cruiser 10–13 Seater',
    price: 4000,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Cruiser-13-Seater.jpg',
    description: 'Comfortable cruiser for medium-sized groups and sightseeing trips.',
    features: [
      '10–13 Passengers',
      'Comfort Seats',
      'Group Travel',
      'City & Outstation',
      'Professional Driver'
    ]
  },
  {
    id: 'urbania',
    name: 'Urbania 16 Seater',
    price: 7500,
    image: 'https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/urbania-trav.png',
    description: 'Modern luxury van designed for premium group travel.',
    features: [
      '16 Passengers',
      'Luxury Van',
      'Premium Interior',
      'Smooth Suspension',
      'Professional Driver'
    ]
  }
];


  const locationImages = [
    'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    'https://varanasismartcity.gov.in//assets/images/images/DashashwamedhGhat.jpg',
    'https://kashi.gov.in/cmsadmin/getApiFile/CMS/68c3e3b4001a01757668276~jpg',
    'https://images.unsplash.com/photo-1548013146-72479768bada?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80'
  ];

  const locations = [
    'Lal Bahadur Shastri International Airport',
    'Varanasi Railway Station',
    'Assi Ghat',
    'Dashashwamedh Ghat',
    'Sarnath',
    'Bharat Mata Mandir',
    'Banaras Hindu University',
    'Godowlia Chowk'
  ];

  const selectedServiceData = services.find(service => service.id === selectedService);

  const handleBookNow = () => {
    if (bookingStep === 1) {
      setBookingStep(2);
    } else {
      // Simulate booking confirmation
      setBookingConfirmed(true);
      setTimeout(() => {
        setBookingStep(1);
        setBookingConfirmed(false);
        setPickupLocation('Lal Bahadur Shastri International Airport');
        setDropLocation('');
        setPickupDate('');
        setPickupTime('');
        setPassengers(1);
      }, 5000);
    }
  };

  const calculateTotal = () => {
    const basePrice = selectedServiceData.price;
    let total = basePrice;
    
    // Add extra charges for additional passengers
    if (passengers > 4 && selectedService === 'standard') {
      total += (passengers - 4) * 100;
    } else if (passengers > 6 && selectedService === 'suv') {
      total += (passengers - 6) * 150;
    }
    
    return total;
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '+916307291567';
    const message = `Hello, I'm interested in booking an airport transfer service in Varanasi.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCallClick = () => {
    const phoneNumber = '+916307291567';
    window.open(`tel:${phoneNumber}`, '_self');
  };

  return (
    <div className={`airport-transfer-page ${isMobile ? 'mobile-view' : ''}`}>
      {/* WhatsApp Floating Button - Icon Only */}
      <div className="whatsapp-float-btn" onClick={handleWhatsAppClick}>
        <FaWhatsapp className="whatsapp-icon-svg" />
      </div>

      {/* Call Floating Button - Icon Only */}
      <div className="call-float-btn" onClick={handleCallClick}>
        <FaPhoneAlt className="call-icon-svg" />
      </div>

      <header className="ats-header">
        <div className="ats-logo-box">
          <h1 className="ats-logo">VNS<span className="ats-logo-color"> Tour And Travel</span></h1>
          <p className="ats-tagline">Premium Airport Transfers in the Holy City</p>
        </div>
        <div className="ats-header-bg">
          <div className="ats-header-overlay"></div>
        </div>
      </header>

      <main className="ats-main">
        <div className="ats-container">
          <div className="ats-intro">
            <h2 className="ats-title">Airport Transfer Service</h2>
            <p className="ats-desc">
              Experience seamless and comfortable airport transfers in Varanasi. 
              Our professional drivers ensure a safe and timely journey to your destination 
              with the convenience of pre-booking and transparent pricing.
            </p>
          </div>

          

          <div className="ats-booking-area">
            <div className="ats-booking-card ats-animated">
              <div className="ats-booking-header">
                <h3 className="ats-booking-title">Book Your Airport Transfer</h3>
                <div className="ats-step-indicator">
                  <span className={`ats-step ${bookingStep === 1 ? 'ats-step-active' : ''}`}>1</span>
                  <div className="ats-step-line"></div>
                  <span className={`ats-step ${bookingStep === 2 ? 'ats-step-active' : ''}`}>2</span>
                </div>
              </div>

              {bookingStep === 1 ? (
                <div className="ats-service-section">
                  <h4 className="ats-service-title">Select Your Vehicle</h4>
                  <div className="ats-service-grid">
                    {services.map(service => (
                      <div 
                        key={service.id} 
                        className={`ats-service-card ${selectedService === service.id ? 'ats-service-selected' : ''}`}
                        onClick={() => setSelectedService(service.id)}
                      >
                        <div 
                          className="ats-service-image" 
                          style={{backgroundImage: `url(${service.image})`}}
                        ></div>
                        <div className="ats-service-details">
                          <h5 className="ats-service-name">{service.name}</h5>
                          <p className="ats-service-desc">{service.description}</p>
                          <div className="ats-service-features">
                            {service.features.map((feature, index) => (
                              <span key={index} className="ats-feature-tag">{feature}</span>
                            ))}
                          </div>
                          <div className="ats-service-price">
                            <span className="ats-price">₹{service.price}</span>
                            <span className="ats-price-note">per trip</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="ats-booking-form">
                    <div className="ats-form-group">
                      <label htmlFor="pickup" className="ats-form-label">
                        <FaMapMarkerAlt className="ats-form-icon" /> Pickup Location
                      </label>
                      <select 
                        id="pickup" 
                        value={pickupLocation}
                        onChange={(e) => setPickupLocation(e.target.value)}
                        className="ats-form-select"
                      >
                        {locations.map(location => (
                          <option key={location} value={location}>{location}</option>
                        ))}
                      </select>
                    </div>

                    <div className="ats-form-group">
                      <label htmlFor="drop" className="ats-form-label">
                        <FaMapMarkerAlt className="ats-form-icon" /> Drop Location
                      </label>
                      <select 
                        id="drop" 
                        value={dropLocation}
                        onChange={(e) => setDropLocation(e.target.value)}
                        className="ats-form-select"
                      >
                        <option value="">Select drop location</option>
                        {locations.filter(loc => loc !== pickupLocation).map(location => (
                          <option key={location} value={location}>{location}</option>
                        ))}
                      </select>
                    </div>

                    <div className="ats-form-row">
                      <div className="ats-form-group">
                        <label htmlFor="date" className="ats-form-label">
                          <FaClock className="ats-form-icon" /> Pickup Date
                        </label>
                        <input 
                          type="date" 
                          id="date" 
                          value={pickupDate}
                          onChange={(e) => setPickupDate(e.target.value)}
                          className="ats-form-input"
                        />
                      </div>

                      <div className="ats-form-group">
                        <label htmlFor="time" className="ats-form-label">
                          <FaClock className="ats-form-icon" /> Pickup Time
                        </label>
                        <input 
                          type="time" 
                          id="time" 
                          value={pickupTime}
                          onChange={(e) => setPickupTime(e.target.value)}
                          className="ats-form-input"
                        />
                      </div>

                      <div className="ats-form-group">
                        <label htmlFor="passengers" className="ats-form-label">
                          <FaUserFriends className="ats-form-icon" /> Passengers
                        </label>
                        <div className="ats-passenger-selector">
                          <button 
                            className="ats-passenger-btn" 
                            onClick={() => setPassengers(prev => Math.max(1, prev - 1))}
                          >-</button>
                          <span className="ats-passenger-count">{passengers}</span>
                          <button 
                            className="ats-passenger-btn" 
                            onClick={() => setPassengers(prev => prev + 1)}
                          >+</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ats-confirm-section">
                  <h4 className="ats-confirm-title">Confirm Your Booking</h4>
                  <div className="ats-confirm-details">
                    <div className="ats-detail-row">
                      <span className="ats-detail-label">Service:</span>
                      <span className="ats-detail-value">{selectedServiceData.name}</span>
                    </div>
                    <div className="ats-detail-row">
                      <span className="ats-detail-label">Pickup:</span>
                      <span className="ats-detail-value">{pickupLocation}</span>
                    </div>
                    <div className="ats-detail-row">
                      <span className="ats-detail-label">Drop:</span>
                      <span className="ats-detail-value">{dropLocation || 'Not selected'}</span>
                    </div>
                    <div className="ats-detail-row">
                      <span className="ats-detail-label">Date & Time:</span>
                      <span className="ats-detail-value">{pickupDate} at {pickupTime || 'Not selected'}</span>
                    </div>
                    <div className="ats-detail-row">
                      <span className="ats-detail-label">Passengers:</span>
                      <span className="ats-detail-value">{passengers}</span>
                    </div>
                    <div className="ats-detail-row ats-total-row">
                      <span className="ats-detail-label">Total Amount:</span>
                      <span className="ats-detail-value ats-total-price">₹{calculateTotal()}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="ats-booking-actions">
                {bookingStep === 2 && (
                  <button 
                    className="ats-btn-secondary" 
                    onClick={() => setBookingStep(1)}
                  >
                    Back
                  </button>
                )}
                <button 
                  className="ats-btn-primary" 
                  onClick={handleBookNow}
                  disabled={bookingStep === 1 && (!pickupDate || !pickupTime || !dropLocation)}
                >
                  {bookingStep === 1 ? 'Proceed to Confirm' : 'Confirm Booking'}
                </button>
              </div>
            </div>

            <div className="ats-features-grid">
              <div className="ats-feature-card ats-animated ats-delay-1">
                <div className="ats-feature-icon-box">
                  <FaCar className="ats-feature-icon" />
                </div>
                <h4 className="ats-feature-title">24/7 Service</h4>
                <p className="ats-feature-text">Available round the clock for all flights</p>
              </div>

              <div className="ats-feature-card ats-animated ats-delay-2">
                <div className="ats-feature-icon-box">
                  <FaShieldAlt className="ats-feature-icon" />
                </div>
                <h4 className="ats-feature-title">Safe & Secure</h4>
                <p className="ats-feature-text">Verified drivers with safety protocols</p>
              </div>

              <div className="ats-feature-card ats-animated ats-delay-3">
                <div className="ats-feature-icon-box">
                  <FaClock className="ats-feature-icon" />
                </div>
                <h4 className="ats-feature-title">On-time Guarantee</h4>
                <p className="ats-feature-text">Track your ride with real-time updates</p>
              </div>

              <div className="ats-feature-card ats-animated ats-delay-4">
                <div className="ats-feature-icon-box">
                  <FaPhoneAlt className="ats-feature-icon" />
                </div>
                <h4 className="ats-feature-title">24/7 Support</h4>
                <p className="ats-feature-text">Always available to assist you</p>
              </div>
            </div>
          </div>

          {bookingConfirmed && (
            <div className="ats-confirm-modal">
              <div className="ats-confirm-content">
                <div className="ats-confirm-check">✓</div>
                <h3 className="ats-confirm-modal-title">Booking Confirmed!</h3>
                <p className="ats-confirm-modal-text">Your airport transfer from {pickupLocation} has been successfully booked.</p>
                <p className="ats-confirm-modal-text">Booking reference: <strong>VNS{Math.floor(Math.random() * 10000)}</strong></p>
                <p className="ats-confirm-modal-text">Driver details and vehicle information will be sent to you shortly.</p>
                <p className="ats-thankyou">Thank you for choosing Varanasi Cab Services!</p>
              </div>
            </div>
          )}
        </div>
      </main>

      
    </div>
  );
};

export default AirportTransfer;